import classNames from 'classnames'
import { ChangeEvent } from 'react'
import { FormattedText, ToggleSwitch } from 'src/modules/core/components'
import type { PlansIntervalToggleProps } from './plans-interval-toggle.interface'
import classes from './plans-interval-toggle.module.scss'

export function PlansIntervalToggle({ isYearly, onChange, currencyLabel }: PlansIntervalToggleProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)

  return (
    <div className={classes.root}>
      <div className={classes.switch}>
        <span className={classNames(classes.label, { [classes.selected]: !isYearly })}>
          <FormattedText id="payment.switch.monthly" />
        </span>
        <ToggleSwitch
          variant="primary"
          name="periodSwitch"
          checked={isYearly}
          onChange={handleChange}
          labelClassName={classes.track}
        />
        <span className={classNames(classes.label, { [classes.selected]: isYearly })}>
          <FormattedText id="payment.switch.yearly" />
        </span>
        <span className={classes.pill}>
          <FormattedText id="payment.plans.interval.twoMonthsFree" />
        </span>
      </div>
      <span className={classes.terms}>
        {currencyLabel ? (
          <FormattedText id="payment.plans.interval.termsWithCurrency" values={{ currency: currencyLabel }} />
        ) : (
          <FormattedText id="payment.plans.interval.terms" />
        )}
      </span>
    </div>
  )
}
